<template>
  <v-container
    :class="[
      { 'bg bg--gray': !onboardingFlow },
      { 'pa-0': onboardingFlow },
    ]"
    fill-height
    fluid
  >
    <OnboardingForm v-if="onboardingFlow" />

    <LoginBox v-else>
      <DefaultForm />
    </LoginBox>
  </v-container>
</template>

<script>
import OnboardingForm from 'components/pages/resetPassword/OnboardingForm'
import DefaultForm from 'components/pages/resetPassword/DefaultForm'

export default {
  name: 'ResetPasswordPage',
  components: {
    OnboardingForm,
    DefaultForm
  },
  computed: {
    onboardingFlow () {
      return Boolean(this.$route.query?.onboarding)
    }
  }
}
</script>
